export const AT_IN_WORK_USERS_UPDATE = 'CARD_IN_WORK_USERS_UPDATE';
export const AT_UPDATE = 'CARD_UPDATE';
export const AT_NOTIFICATION_BEFORE_DUEDATE_ADD = 'CARD_NOTIFICATION_BEFORE_DUEDATE_ADD';
export const AT_NOTIFICATION_BEFORE_DUEDATE_UPDATE = 'CARD_NOTIFICATION_BEFORE_DUEDATE_UPDATE';
export const AT_NOTIFICATION_BEFORE_DUEDATE_DELETE = 'CARD_NOTIFICATION_BEFORE_DUEDATE_DELETE';
export const AT_DRIVE_DOC_IDS_SET = 'CARD_DRIVE_DOC_IDS_SET';
